import React from 'react';

const Preview: React.FC = () => (
  <div className="h-full bg-white flex flex-col items-center justify-center p-4">
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" className="mb-3">
      <rect width="56" height="56" rx="12" fill="#2563eb" />
      <rect x="10" y="16" width="36" height="24" rx="3" fill="none" stroke="white" strokeWidth="2" />
      <path d="M10 18l18 12 18-12" stroke="white" strokeWidth="2" fill="none" />
    </svg>
    <div className="text-sm font-medium text-gray-700">Outlook Email</div>
    <div className="text-xs text-gray-400 mt-1 text-center max-w-48">
      Compose and send emails through Microsoft Outlook
    </div>
  </div>
);

export default Preview;
